import {Stack, Typography, Paper} from "@mui/material";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function CategoriesOptionalDisplay(props) {
  // const [mappings, setMappings] = useState(props.mappings);
  const {mappings, domain, spatial, temporal, multilingualityType, lcrSubclass,
    corpusSubclass, linguisticInformation, annotationType, languageType, defaultLanguage, topLabel} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }

  if (domain.isEmpty() &&
    linguisticInformation.isEmpty() &&
    isEmpty(spatial.getList()) &&
    (!temporal || temporal.getObjList().length === 0) &&
    // isEmpty(conformsTo.getList()) &&
    isEmpty(getLabel(multilingualityType.getValue())) &&
    isEmpty(getLabel(languageType.getValue())) &&
    isEmpty(getLabel(lcrSubclass.getValue())) &&
    isEmpty(getLabel(corpusSubclass.getValue())) &&
    isEmpty(annotationType.getList())) return null;

  return (
    <> {/* <Paper variant="outlined"> */}
      {/* <Typography variant="h4" gutterBottom noWrap>{topLabel}</Typography> */}
      <Stack direction="column" alignItems="flex-start" justifyContent="flex-start">
        <Stack sx={{pt: 1}} spacing={1}>
          {!domain.isEmpty() && (
            <div>
              <Typography variant="body2" className={"key"}>
                {getLabel(keys.domain, "domain")}
              </Typography>
              {domain.getList().map((item, index) => (
                <div key={index}>
                  {getLabel(item.getValue(), "")}
                </div>
              ))}
            </div>
          )}

          {!isEmpty(getLabel(corpusSubclass.getValue())) && (
            <div>
              <Typography variant="body2" className={"key"}>
                {getLabel(keys.corpusSubclass, "corpusSubclass")}
              </Typography>
              <Typography variant="body1">{getLabel(corpusSubclass.getValue())}</Typography>
            </div>
          )}

          {!isEmpty(getLabel(lcrSubclass.getValue())) && (
            <div>
              <Typography variant="body2" className={"key"}>
                {getLabel(keys.lcrSubclass, "lcrSubclass")}
              </Typography>
              <Typography variant="body1">{getLabel(lcrSubclass.getValue())}</Typography>
            </div>
          )}

          {!linguisticInformation.isEmpty() && (
            <div>
              <Typography variant="body2" className={"key"}>
                {getLabel(keys.linguisticInformation, "linguisticInformation")}
              </Typography>
              {linguisticInformation.getList().map((item, index) => (
                <div key={index}>
                  {getLabel(item.getValue(), "")}
                </div>
              ))}
            </div>
          )}

          {!isEmpty(spatial.getList()) && (
            <div>
              <Typography variant="body2" className={"key"}>
                {getLabel(keys.spatial, "spatial")}
              </Typography>
              {spatial.getList().map((item, index) => (
                <div key={index}>
                  {getLabel(item.getValue(), "")}
                </div>
              ))}
            </div>
          )}

          {!isEmpty(getLabel(multilingualityType.getValue())) && (
            <div>
              <Typography variant="body2" className={"key"}>
                {getLabel(keys.multilingualityType, "multilingualityType")}
              </Typography>
              <Typography variant="body1">{getLabel(multilingualityType.getValue())}</Typography>
            </div>
          )}

          {!isEmpty(getLabel(languageType.getValue())) && (
            <div>
              <Typography variant="body2" className={"key"}>
                {getLabel(keys.languageType, "languageType")}
              </Typography>
              <Typography variant="body1">{getLabel(languageType.getValue())}</Typography>
            </div>
          )}

          {!isEmpty(annotationType.getList()) && (
            <div>
              <Typography variant="body2" className={"key"}>
                {getLabel(keys.annotationType, "annotationType")}
              </Typography>
              {annotationType.getList().map((item, index) => (
                <div key={index}>
                  {getLabel(item.getValue(), "")}
                </div>
              ))}
            </div>
          )}

          {temporal && temporal.getObjList().length > 0 && <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>
            {getLabel(keys.temporal, "temporal")}
          </Typography>}
          {temporal && temporal.getObjList().map((item, index) => {
            return (!isEmpty(item.startDate.getValue(), item.endDate.getValue()) && (
              <Stack key={index} sx={{pt: 1}} spacing={1}>
                <div>
                  <Typography variant="body2" className={"key"}>
                    {getLabel(keys.startDate, "startDate")}
                  </Typography>
                  <Typography variant="body1">{item.startDate.getValue()}</Typography>
                </div>
                <div>
                  <Typography variant="body2" className={"key"}>
                    {getLabel(keys.endDate, "endDate")}
                  </Typography>
                  <Typography variant="body1">{item.endDate.getValue()}</Typography>
                </div>
              </Stack>
            ));
          })}
        </Stack>
      </Stack>
    </>
  );
}
